<div class="container-fluid fixed-top gx-0 bg-primary-50 shadow-8">
    <div class="row justify-content-center">
        <div class="col-4 d-flex justify-content-center align-items-center py-2">
            <img src="assets/images/blast/pedro-club-logo-light.svg" alt="blast-icon"
                class="img-fluid icono-50 me-4 pt-2">
            <img src="assets/images/venture/SegoVenture_HN.svg" alt="venture-icon" class="img-fluid icono-50">
        </div>
    </div>
</div>